import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/69dc07c7a74957001427cc5c/hiretruckers365/node_modules/lucide-react/dist/esm/Icon.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/69dc07c7a74957001427cc5c/hiretruckers365/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/69dc07c7a74957001427cc5c/hiretruckers365/src/app/landing-page/components/LandingFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/69dc07c7a74957001427cc5c/hiretruckers365/src/app/landing-page/components/LandingNav.tsx");
